module.exports = __webpack_public_path__ + "img/utel-logo.c88c05cc.webp";